import { inject } from '@angular/core';
import {
  Router,
  type ActivatedRouteSnapshot,
  type CanActivateFn,
  type RouterStateSnapshot,
  type UrlTree,
} from '@angular/router';
import type { AuthGuardData } from 'keycloak-angular';
import { createAuthGuard } from 'keycloak-angular';

const isNotAuthenticated = (
  _route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  { authenticated }: AuthGuardData,
): Promise<boolean | UrlTree> => Promise.resolve(authenticated ? inject(Router).parseUrl('/') : true);

export const guestGuard = createAuthGuard<CanActivateFn>(isNotAuthenticated);
